module.exports = __webpack_public_path__ + "static/media/Resume.501b15f4.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/Resume.pdf
// module id = 467
// module chunks = 0